export const saveUserInState = (user) => {
    return {
        type: 'UPDATE_USER',
        payload: user,
    };
};

export const deleteUserInState = () => {
    return {
        type: 'DELETE_USER',
    };
};

export const updateOrderInState = (order) => {
    return {
        type: 'UPDATE_ORDER',
        payload: order,
    };
};

export const deleteOrderInState = () => {
    return { type: 'DELETE_ORDER' };
};

export const updateOrderCopyInState = (order) => {
    return {
        type: 'UPDATE_ORDER_COPY',
        payload: order,
    };
};

export const deleteOrderCopyInState = () => {
    return { type: 'DELETE_ORDER_COPY' };
};
